import { centerAligned } from '@medly-components/utils';
import styled from 'styled-components';

export const SliderActionWrapper = styled('div')`
    ${centerAligned('flex')}
    gap: 1.2rem;
`;

export const SliderActionButton = styled('button')`
    height: 4rem;
    width: 4rem;
    background: transparent;
    border-radius: 2rem;
    outline: none;
    cursor: pointer;
    border: 0.1rem solid ${({ theme }) => theme.colors.grey[500]};
    ${centerAligned('flex')}

    svg * {
        fill: ${({ theme, disabled }) => (disabled ? '' : theme.font.defaults.color)};
    }

    &:disabled {
        cursor: not-allowed;
    }
`;
